import { render, staticRenderFns } from "./PhotoWall.vue?vue&type=template&id=0a6435d8&scoped=true&"
import script from "./PhotoWall.vue?vue&type=script&lang=js&"
export * from "./PhotoWall.vue?vue&type=script&lang=js&"
import style0 from "./PhotoWall.vue?vue&type=style&index=0&id=0a6435d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6435d8",
  null
  
)

export default component.exports